import React, { useState, useEffect } from 'react';
import { getDepartmentList } from '../../../../services/departmentService';
import { getStaffPayRatesReport } from '../../../../services/staffService';
import { toast } from "react-toastify";
import Select from '../../../Common/form/select';
import auth from "../../../../services/authService";

function StaffPayRateFilters({ setDepartmentIdSelected, setDepartmentNameSelected, departmentIdSelected, numberStaffMembers }) {
  const [departments, setDepartments] = useState([]);

  const userData = auth.getCurrentUser();
  const userDepartmentId = userData.department_id;
  const userDepartmentName = userData.department_name;

  const setDepartmentSelected = (input) => {
    let selectedDepartment = '';
    departments.forEach(function (department) {
      if (department.id === Number(input.value)) {
        selectedDepartment = department.name;
      }
    });

    setDepartmentIdSelected(Number(input.value));
    setDepartmentNameSelected(selectedDepartment);
  }

  useEffect(() => {
    const fetchDepartmentsList = async () => {
      const { data } = await getDepartmentList();
      setDepartments(data.department);
      if (userDepartmentId) {
        setDepartmentIdSelected(userDepartmentId);
      } else if (data.department[0]) {
        setDepartmentIdSelected(data.department[0].id);
      }
    }
    fetchDepartmentsList();
  }, []);

  // ** HANDLES
  // *********************************************************
  const handlePrintOption = async () => {
    const {data: resReportSheet } = await getStaffPayRatesReport(departmentIdSelected);
    if (!resReportSheet.success) return toast.error("Print file couldn't be generated");
    window.open(process.env.REACT_APP_API_URL + '/' + resReportSheet.file_name);
  }

  return (
    <div className="StaffPayRateFilters">
      <div className="row align-items-center">
        <div className="col-auto">
          <h3 className="setting-label">
            <i className="fas fa-id-badge"></i>
            &nbsp;Staff &amp; pay rates for&nbsp;
            {userDepartmentId &&
              userDepartmentName
            }
          </h3>
        </div>
        <div className="col-sm-2">
            {!userDepartmentId &&
              <Select
                name={'selectDepartment'}
                options={departments}
                onChange={({ currentTarget: input }) => setDepartmentSelected(input) }
              />
            }
        </div>
      </div>
      <div className="row">
        <div className="col-auto">
          Number of active staff members: <strong>{numberStaffMembers}</strong>
        </div>
      </div>
      <div className="row">
        <div className="export-container">
          <button className="btn btn-print-options" type="button" onClick={() => handlePrintOption()} >
            <i className="far fa-file-pdf"></i> EXPORT TO PDF
          </button>
        </div>
      </div>
    </div>
  )
}

export default StaffPayRateFilters
